module.exports = __webpack_public_path__ + "img/product-placeholder-53.c9c515d.png";